import App from './App';
import Vue from 'vue';
import router from './router';
import ElementUI from 'element-ui';              //element-ui组件
import 'element-ui/lib/theme-chalk/index.css';   //element-ui样式
import './assets/iconfont/iconfont.css';
import arUI from './components/anyUI/index';
import './assets/css/base.css';

Vue.use(arUI);
import axios from 'axios';                  //引入axios
import VueAxios from 'vue-axios';           //？？
import echarts from 'echarts';
Vue.prototype.$echarts = echarts;
import storage from './components/js/storage.js';//$storage
Vue.prototype.$storage = storage;
Vue.use(VueAxios, axios);
import {post, get, gethttp, posthttp} from './api/httpService';
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$gethttp = gethttp;
Vue.prototype.$posthttp = posthttp;

Vue.use(ElementUI);
Vue.config.productionTip = false;
import errorCode from './config/constant.js';;
import md5 from 'js-md5';
Vue.prototype.$MD5 = md5;
Vue.prototype.$axios = axios;
Vue.prototype.errorCode = errorCode;

import Tables from './components/tables/index';
Vue.use(Tables);
import Echarts from './components/echarts/index';
Vue.use(Echarts);
import Times from './components/times/index';
Vue.use(Times);

//所有的数据返回处理code
axios.interceptors.response.use(
    res =>{
        if (res.data) {
          if (res.data.data) {
             if (res.data.data.code === 0) {
               return res;
             }  else {
               console.log("error：", res);
               Vue.prototype.$message.error(errorCode[res.data.data.code]);
               return Promise.reject(res.data.data.msg);
             }
          } else {
            return res;
          }
        } else {
          return Promise.reject(res.data.data.msg);
        }
    },
    err =>{
        if (err.response) {
            switch (err.response.status) {
                case 401:
                // 返回 401 清除token信息并跳转到登录页面
                router.replace({ path: '/login' })
                Vue.prototype.$message.error('登录已过期')
            }
        }
        Vue.prototype.$storage.removeStorage('user');
    }
)
router.beforeEach((to, from, next) => {
    var user = Vue.prototype.$storage.getStorage('user');
    if (to.path == '/login') {
        Vue.prototype.$storage.removeStorage('user');
        next();
    }else{
        if(user != null){
            // var params = {}
            Vue.prototype.$gethttp('/isSignIn', { 'userId' : user })
            .then((res)=>{
                if(to.path == '' || to.path == '/'){
                    next({path : '/overview'});
                }else{
                    next();
                }
            })
        }else{
            next({path : '/login'});
        }
    }
})
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js